





import {Component, Prop, Watch} from "vue-property-decorator"
import Vue from "vue"
import {ActiveProvide} from "@/support/reactive"


@Component({})
export default class ProviderMulti extends Vue {
    @ActiveProvide('jds.test.provide1') var1 = '';
    @ActiveProvide('jds.test.provide2') var2 = '';
    @Prop() toInject1!: string;
    @Prop() toInject2!: string;

    @Watch('toInject1', {immediate: true})
    syncProvide() {
        this.var1 = this.toInject1;
    }

    @Watch('toInject2', {immediate: true})
    syncProvide2() {
        this.var2 = this.toInject2;
    }
}
